// TODO: затипизировать

const getOrCreateTooltip = (chart, chartToolTipId) => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div');
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = chartToolTipId;

    tooltipEl.style =
      'width: fit-content; padding: 1.0625rem 2.3125rem; display: flex; align-items: center; position: absolute; transform: translate(-50%, 0); background: rgba(50, 5, 72, 1); border-radius: 0.3536rem; pointer-events: none; border: 1px solid rgba(104, 41, 132, 1);';

    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

export const externalTooltipHandler = (context, title, chartToolTipId, isMobile = false, originalLabels2) => {
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart, chartToolTipId);

  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  if (tooltip.body) {
    const dp = tooltip.dataPoints && tooltip.dataPoints[0];
    // самый простой вариант -  сравниваем по цвету, если цвет зеленый то подменяем дату на оригинальную т.к. зеленый цвет у data2 которые в свою очередь являются данными за предыдущий период
    const label = dp.dataset.borderColor === 'rgba(67, 172, 106, 1)' ? originalLabels2[dp.dataIndex] : dp?.label ?? '';
    const value = tooltip.body.map(b => b.lines)[0];

    const tooltipRoot = document.getElementById(chartToolTipId);
    while (tooltipRoot?.firstChild) {
      tooltipRoot.firstChild.remove();
    }

    const wrap = document.createElement('div');
    wrap.style = 'display:flex; flex-direction:column; gap:0.375rem;';

    const makeDot = (color) => {
      const dot = document.createElement('div');
      dot.style =
        `background:${color}; width:0.875rem; min-width:0.875rem; height:0.875rem; border-radius:50%; margin-right:0.625rem`;
      return dot;
    };

    let dsColor = 'rgba(177, 0, 255, 1)';
    if (dp && chart.data && chart.data.datasets && chart.data.datasets[dp.datasetIndex]) {
      const ds = chart.data.datasets[dp.datasetIndex];
      dsColor = ds.pointBorderColor || ds.borderColor || dsColor;
    }

    const makeRow = (leftLabelText, rightValueText) => {
      const row = document.createElement('div');
      row.style = 'display:flex; align-items:center; justify-content:space-between; gap: 2.5rem;';

      const left = document.createElement('div');
      left.style = 'display:flex; align-items:center; font-weight:700; font-size:0.75rem;';
      left.appendChild(makeDot(dsColor));
      left.appendChild(document.createTextNode(leftLabelText));

      const right = document.createElement('div');
      right.style = 'font-weight:700; font-size:0.75rem;';
      right.appendChild(document.createTextNode(rightValueText));

      row.appendChild(left);
      row.appendChild(right);
      return row;
    };

    // 1) Total
    wrap.appendChild(makeRow(title, value));
    // 2) Date
    wrap.appendChild(makeRow('Date', label));

    tooltipEl.appendChild(wrap);
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  tooltipEl.style.opacity = 1;
  tooltipEl.style.top = `${positionY + tooltip.caretY}px`;
  tooltipEl.style.font = tooltip.options.bodyFont.string;

  // что бы тултип не вылезал за границы канваса
  if (tooltip.x + tooltipEl.offsetWidth > chart.canvas.offsetWidth) {
    tooltipEl.style.left = `auto`;
    tooltipEl.style.right = `0px`;
    tooltipEl.style.transform = `none`;
  } else if (tooltip.x - tooltipEl.offsetWidth / 2 < 0) {
    tooltipEl.style.right = `auto`;
    tooltipEl.style.left = `0px`;
    tooltipEl.style.transform = `none`;
  } else {
    tooltipEl.style.right = `auto`;
    tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
    tooltipEl.style.transform = `translate(-50%, 0)`;
  }
};
